<template>
  <div class="audio-join-status-block">
    <ym-tag v-if="joinStatus === 'member'"
              type="disabled"
              size="medium"
              round
    >
      <ym-icon class="select-icon"
                name="select"
      />
      已订阅
    </ym-tag>
    <ym-tag v-else
            type="gold"
            size="medium"
            round
    >
      会员专享
    </ym-tag>
  </div>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';

  export default {
    name: 'AudioJoinStatusBlock',
    components: {
      YmTag: Tag,
    },
    props: {
      joinStatus: {
        type: String,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .select-icon {
    font-size: 24px;
    margin-right: @size-extra-small;
  }
</style>
